import {createSelector} from '@reduxjs/toolkit'
import { 
    APPLICATION_STATUS_APPROVED_ISSUED, 
    APPLICATION_STATUS_PENDING_PAYMENT, 
    LICENCE_STATUS_ACTIVE, 
    LICENCE_STATUS_EXPIRED, 
    LICENCE_STATUS_NEW,
    LICENCE_STATUS_REVOKED,
    LICENCE_STATUS_WITHDRAWN,
    LICENCE_STATUS_WITHDRAWN_BY_CLIENT
} from '../../app/constants'
import { IsDateInFuture, IsDateYearCurrentYear, IsTodayWithinRange } from "../../app/utils";
import { isRenewalTypeApplication } from '../slice/applicationsUtils'

const collectorsReviewSelector = createSelector(
    [state => state.components, 
    state => state.additionalApplications, 
    (state) => state.primaryAgencyApplication.licenceTypeDetails],
    (components, additionalApplications, licenceTypeDetails) => {

        const canRenewApplication = (application) => {
            // if licence status is set to EXPIRED | REJECTED | CANCELLED_BY_CLIENT | CANCELLED, it can not be renewed. 
            if(application.licenceStatus === LICENCE_STATUS_EXPIRED
                || application.licenceStatus === LICENCE_STATUS_REVOKED
                || application.licenceStatus === LICENCE_STATUS_WITHDRAWN
                || application.licenceStatus === LICENCE_STATUS_WITHDRAWN_BY_CLIENT) {
                return false;
            }

            return true;
        }

        const isApplicationDueForRenewal = (application) => {
            const licenceType = licenceTypeDetails?.businessLicenceStatusList?.[0]
            const startDate = licenceType?.renewalStartDate
            const endDate = licenceType?.renewalGraceDate ?? licenceType?.renewalEndDate

            // licence expiry date.
            const licenceExpiry = application?.endDate ?? 0

            // today's date is within the renewal range (taking into account grace period)
            // and the licence expiry is this year
            // and the licence expiry is in future
            const isAgencyRenewalEnable = (startDate && endDate) ? (
                IsTodayWithinRange(startDate, endDate) && 
                IsDateYearCurrentYear(licenceExpiry) && 
                IsDateInFuture(licenceExpiry)) : false

            // case : licence has expired (post expiry date) but still in grace period
            const isExpiredInGracePeriod = ((application?.licenceStatus === LICENCE_STATUS_EXPIRED) && IsDateInFuture(endDate))

            // case : renewal type application, still not paid and in grace period
            const isDraftInGracePeriod = (isRenewalTypeApplication(application) 
                                            && (application?.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT)
                                            && IsDateInFuture(endDate))

            return (isAgencyRenewalEnable || isExpiredInGracePeriod || isDraftInGracePeriod)
        }

        let collectors = additionalApplications.agentApplications
                            .filter(agentApp => {
                                
                                // regular application, expired or still active but due for renewal
                                if(!canRenewApplication(agentApp) || !isApplicationDueForRenewal(agentApp)) {
                                    return false
                                }

                                if(isRenewalTypeApplication(agentApp)) {
                                    //  renewal application
                                    if ((agentApp.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT
                                            && agentApp.licenceStatus === LICENCE_STATUS_NEW)) 
                                    {
                                        // case 1 : applied for renewal but not paid yet
                                        return true
                                    }
                                    else if (agentApp.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED 
                                        && (agentApp.licenceStatus === LICENCE_STATUS_ACTIVE 
                                            || agentApp.licenceStatus === LICENCE_STATUS_EXPIRED))
                                    {
                                        // case 2 : expired or still active but due for renewal
                                        return true
                                    }
                                } else if(agentApp.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED 
                                        && (agentApp.licenceStatus === LICENCE_STATUS_ACTIVE 
                                            || agentApp.licenceStatus === LICENCE_STATUS_EXPIRED)) {
                                    return true
                                }

                                return false
                            })
                            .sort((p1, p2) => {
                                let cmpVal = 0;
                        
                                // shift removes last element from array and returns the element
                                const fn1 = p1.contactName?.trim().toLowerCase().split(" ").shift()
                                const fn2 = p2.contactName?.trim().toLowerCase().split(" ").shift()
                        
                                if (fn1 > fn2) cmpVal = 1;
                                else if (fn1 < fn2) cmpVal = -1;
                                return cmpVal;
                              })
                            .map(agentApp => {
                                    return {
                                        id : agentApp.id,
                                        contactName: agentApp.contactName,
                                        markedDoNotRenew : agentApp.markedDoNotRenew
                                    }
                                })

            const licenceType = licenceTypeDetails?.businessLicenceStatusList?.[0]
            const endDate = licenceType?.renewalEndDate

        return Object.assign({},components.collectorsReview, {
            collectors, 
            renewalEndDate : endDate
        })
    }
)

export const collectorsReviewSelect = state => ({
    collectorsReview: collectorsReviewSelector(state)
})
